// Code generated by graphql-codegen. DO NOT EDIT.
/* eslint-disable */ // @ts-nocheck
import { z } from 'zod'
import { VoucherListInput, VoucherLimitType, VoucherIssuedMarkVoucherAsUsedInput, VoucherIssuedMarkVoucherAsUnUsedInput, VoucherIssuedForCampaignMarkVoucherAsUsedInput, VoucherIssuedForCampaignMarkVoucherAsUnUsedInput, VoucherIssuedForCampaignInput, VoucherInput, VoucherI18nInput, VoucherGiftInfoInput, VoucherForCampaignUserItemInput, VoucherForCampaignInput, TllRoomObjectInput, TllPlanType, TllMasterObjectInput, TimeZone, TestEmailInput, SubOptionItemInput, StockHeaderItemInput, StatusReservation, SnackType, SnackSnsType, SnackSnsIconInput, SnackSnsColor, SnackSettingsInput, SnackOwnerType, SnackInput, SnackSnsIconsSettingInput, SnackBlocksInput, SnackBlocksI18nInput, SnackBlockItemType, SnackBlockItemInput, SnackBlockItemContainerInput, SiteControllerType, SiteControllerSettingTllInput, SiteControllerSettingTemairazuInput, SiteControllerSettingNotUsingInput, SiteControllerSettingNeppanInput, SiteControllerSettingBeds24MasterDataSyncInput, SiteControllerSettingBeds24Input, SiteControllerSettingAirHostReservationSyncStartInput, SiteControllerSettingAirHostChillnnRoomAndAirHostPricePlanMappingsInput, SiteControllerSettingAirHostBaseInfoInput, SalesMastType, SaleTypeForTerm, SaleTypeForPlan, RoomStockObjectInput, RoomStockInput, RoomStockDailyItemInput, RoomQueryKidsItemInput, RoomQueryItemInput, RoomPriceRankMastInput, RoomPriceRankDailyStatusInput, RoomPriceObjectInput, RoomListInput, RoomI18nArticleInput, RoomDummyInput, RoomDummyI18nInput, RoomArticleInput, SendingMethod, ReservationRequestHandlingInput, ReservationRefundRequestInput, ReservationLocalCancelFeeRejectInput, ReservationLocalCancelFeeAcceptInput, ReservationDetailUpdateNoShowStatusInput, ReservationDetailUpdateMailMagazineStatusInput, ReservationDetailUpdateIssuedReceiptStatusInput, ReservationDetailUpdateHostMemoInput, ReservationDetailIssueReceiptInput, StatusRequest, StatusRefund, StatusPayment, ReservationCancelInput, ReservationCancelFeeChargeInput, ReservationRequestStatus, ReservationEditor, RegistrationStatusType, ReceiptSettingInput, ReOnboardingRequestInput, Reservation_List_Reservation_Type, Reservation_List_Reservation_Status, Reservation_List_Repeater_Type, QuestionType, QuestionItemInput, ProTicketPurchaseInput, PriceRankRoomItemInput, PriceRankItemInput, PriceRankDailyStatusItemInput, PlanStockObjectInput, PlanStockInput, PlanStockDailyItemInput, PlanListInput, StaticRoomPriceParamsInput, ShortStayParamsInput, PlanI18nArticleInput, PlanCustomMailSettingInput, PlanCustomMailSettingI18nInput, PlanArticleInput, StockTypeTerm, StockTypeTarget, PlainWidgetType, PlainWidgetItemInput, PlainWidgetInput, PlainWidgetI18nInput, PlainWidgetDecoration, PlainSizeType, PlainReservationComponentViewerType, PlainReservationComponentType, PlainFontFamily, PlainBackgroundType, PaymentDepositAccountInput, PaymentCreditInput, OverSiteControllerPeoplePriceInput, OverSiteControllerPeopleNumInput, OptionType, OptionStockObjectInput, OptionStockInput, OptionStockDailyItemInput, OptionPmsItemFromReservationCommentInput, OptionPmsItemFromDirectCommentInput, OptionPmsItemCreateInput, OptionPmsItemCancelInput, PaymentMethod, OptionPmsColorItemInput, OptionListInput, OptionInput, OptionI18nInput, OnboardingVersion, Option_Pms_Item_Type, MealType, MagazineMediaPublicationRequestInput, MagazineAnalyticsSettingInput, LongStayParamsInput, LocalPaymentCancelStatus, LangCode, ReservationDetailUpdateMailResendRequestInput, KidsPolicyType, KidsCosleepingPolicyType, InvoiceSystemSettingsInput, InflowRoute, ImageInput, HotelTemplateType, HotelTemplateSettingsUpdateInput, HotelTemplateSettingsSkipInput, HotelTemplateSettingsResetInput, HotelSetUpInput, HotelPolicyI18nInput, ReservationType, HotelNotificationSettingInput, S3ObjectInput, PlainSettingInput, HotelInfoItemInput, HotelI18nArticleInput, HotelDisplaySettingsInput, HotelArticleInput, HostReceiptType, HpbSettingsInput, HpbPageType, HpbPageUpdateInput, HpbPageCreateInput, HpbOwnerType, GuestPageVisibilitySettingsInput, GuestPageVisibilityMode, GoogleFreeBookingLinksSettingsUpdateHotelTypeInput, GoogleFreeBookingLinksSettingsInput, GoogleFreeBookingLinksSettingsI18nInput, GoogleFreeBookingLinksPhoneType, GoogleFreeBookingLinksPhoneNumberInput, GoogleFreeBookingLinksHotelType, GoogleFreeBookingLinksConnectionStatus, GoogleFreeBookingLinksAddressInput, GeoLocationInput, Facility, EmailTemplateReservationInput, PlanI18nInput, EcReceiptEmailResendInput, DiscountType, DiscountTermType, DiscountTargetType, DiscountResourceType, DiscountOrdinaryI18nInput, DiscountMultiI18nInput, DiscountRoomConditionType, PriceObjectInput, PlanInput, LongTermStayDiscountObjectInput, KidsPolicyItemInput, KidsCosleepingPolicyInput, DiscountOrdinaryInput, DiscountMultiInput, DiscountLongTermInput, DiscountLongTermI18nInput, DayOfTheWeek, CustomTypeRoomTitle, CustomMailSettingTestMailInput, CustomEmailShoppingInput, CustomEmailSettingInput, CustomEmailSettingI18nInput, CustomEmailReservationInput, CustomEmailRequestReservationInput, CurrencyType, ContactUpdateInput, ContactMessageSenderType, ContactMessageItemInput, ContactGenre, ContactCreateInput, ChillnnRoomAndAirHostPricePlanMappingItemInput, ChillnnGuestPageType, CancelPolicyItemInput, BookedGuestSurveyDisplayStatus, BillingTypeTerm, BillingTypeTargetForOption, BillingTypeTarget, ChurnInfo, BillingStatusUpdateInput, Beds24RoomTypeMappingItemInput, BedType, BedItemInput, BasicCustomMailSettingInput, BasicCustomMailSettingI18nInput, BasicCustomMailRequiredItemOverrideInput, BasicCustomMailOptionalItemOverrideInput, BasicCustomMailItemSendRequiredInput, BasicCustomMailItemSendOptionalInput, BasicCustomMailForShoppingInput, BasicCustomMailForReservationOverrideInput, BasicCustomMailForReservationInput, BankInfoInput, HotelPolicyInput, Amenity, AirHostSettingsInput, AirHostReservationSyncJobStatus, AddressObjectInput, RoomInput, RoomI18nInput, HotelInput, HotelI18nInput, AdditionalFeeKidsPriceObjectInput, BillingTypeTermValidation, AdditionalFeeItemInput, AccountTypeHotel } from '../../gql/__generated__/graphql'

type Properties<T> = Required<{
  [K in keyof T]: z.ZodType<T[K], any, T[K]>;
}>;

type definedNonNullAny = {};

export const isDefinedNonNullAny = (v: any): v is definedNonNullAny => v !== undefined && v !== null;

export const definedNonNullAnySchema = z.any().refine((v) => isDefinedNonNullAny(v));

export const VoucherLimitTypeSchema = z.nativeEnum(VoucherLimitType);

export const TllPlanTypeSchema = z.nativeEnum(TllPlanType);

export const TimeZoneSchema = z.nativeEnum(TimeZone);

export const StatusReservationSchema = z.nativeEnum(StatusReservation);

export const SnackTypeSchema = z.nativeEnum(SnackType);

export const SnackSnsTypeSchema = z.nativeEnum(SnackSnsType);

export const SnackSnsColorSchema = z.nativeEnum(SnackSnsColor);

export const SnackOwnerTypeSchema = z.nativeEnum(SnackOwnerType);

export const SnackBlockItemTypeSchema = z.nativeEnum(SnackBlockItemType);

export const SiteControllerTypeSchema = z.nativeEnum(SiteControllerType);

export const SalesMastTypeSchema = z.nativeEnum(SalesMastType);

export const SaleTypeForTermSchema = z.nativeEnum(SaleTypeForTerm);

export const SaleTypeForPlanSchema = z.nativeEnum(SaleTypeForPlan);

export const SendingMethodSchema = z.nativeEnum(SendingMethod);

export const StatusRequestSchema = z.nativeEnum(StatusRequest);

export const StatusRefundSchema = z.nativeEnum(StatusRefund);

export const StatusPaymentSchema = z.nativeEnum(StatusPayment);

export const ReservationRequestStatusSchema = z.nativeEnum(ReservationRequestStatus);

export const ReservationEditorSchema = z.nativeEnum(ReservationEditor);

export const RegistrationStatusTypeSchema = z.nativeEnum(RegistrationStatusType);

export const Reservation_List_Reservation_TypeSchema = z.nativeEnum(Reservation_List_Reservation_Type);

export const Reservation_List_Reservation_StatusSchema = z.nativeEnum(Reservation_List_Reservation_Status);

export const Reservation_List_Repeater_TypeSchema = z.nativeEnum(Reservation_List_Repeater_Type);

export const QuestionTypeSchema = z.nativeEnum(QuestionType);

export const StockTypeTermSchema = z.nativeEnum(StockTypeTerm);

export const StockTypeTargetSchema = z.nativeEnum(StockTypeTarget);

export const PlainWidgetTypeSchema = z.nativeEnum(PlainWidgetType);

export const PlainWidgetDecorationSchema = z.nativeEnum(PlainWidgetDecoration);

export const PlainSizeTypeSchema = z.nativeEnum(PlainSizeType);

export const PlainReservationComponentViewerTypeSchema = z.nativeEnum(PlainReservationComponentViewerType);

export const PlainReservationComponentTypeSchema = z.nativeEnum(PlainReservationComponentType);

export const PlainFontFamilySchema = z.nativeEnum(PlainFontFamily);

export const PlainBackgroundTypeSchema = z.nativeEnum(PlainBackgroundType);

export const OptionTypeSchema = z.nativeEnum(OptionType);

export const PaymentMethodSchema = z.nativeEnum(PaymentMethod);

export const OnboardingVersionSchema = z.nativeEnum(OnboardingVersion);

export const Option_Pms_Item_TypeSchema = z.nativeEnum(Option_Pms_Item_Type);

export const MealTypeSchema = z.nativeEnum(MealType);

export const LocalPaymentCancelStatusSchema = z.nativeEnum(LocalPaymentCancelStatus);

export const LangCodeSchema = z.nativeEnum(LangCode);

export const KidsPolicyTypeSchema = z.nativeEnum(KidsPolicyType);

export const KidsCosleepingPolicyTypeSchema = z.nativeEnum(KidsCosleepingPolicyType);

export const InflowRouteSchema = z.nativeEnum(InflowRoute);

export const HotelTemplateTypeSchema = z.nativeEnum(HotelTemplateType);

export const ReservationTypeSchema = z.nativeEnum(ReservationType);

export const HostReceiptTypeSchema = z.nativeEnum(HostReceiptType);

export const HpbPageTypeSchema = z.nativeEnum(HpbPageType);

export const HpbOwnerTypeSchema = z.nativeEnum(HpbOwnerType);

export const GuestPageVisibilityModeSchema = z.nativeEnum(GuestPageVisibilityMode);

export const GoogleFreeBookingLinksPhoneTypeSchema = z.nativeEnum(GoogleFreeBookingLinksPhoneType);

export const GoogleFreeBookingLinksHotelTypeSchema = z.nativeEnum(GoogleFreeBookingLinksHotelType);

export const GoogleFreeBookingLinksConnectionStatusSchema = z.nativeEnum(GoogleFreeBookingLinksConnectionStatus);

export const FacilitySchema = z.nativeEnum(Facility);

export const DiscountTypeSchema = z.nativeEnum(DiscountType);

export const DiscountTermTypeSchema = z.nativeEnum(DiscountTermType);

export const DiscountTargetTypeSchema = z.nativeEnum(DiscountTargetType);

export const DiscountResourceTypeSchema = z.nativeEnum(DiscountResourceType);

export const DiscountRoomConditionTypeSchema = z.nativeEnum(DiscountRoomConditionType);

export const DayOfTheWeekSchema = z.nativeEnum(DayOfTheWeek);

export const CustomTypeRoomTitleSchema = z.nativeEnum(CustomTypeRoomTitle);

export const CurrencyTypeSchema = z.nativeEnum(CurrencyType);

export const ContactMessageSenderTypeSchema = z.nativeEnum(ContactMessageSenderType);

export const ContactGenreSchema = z.nativeEnum(ContactGenre);

export const ChillnnGuestPageTypeSchema = z.nativeEnum(ChillnnGuestPageType);

export const BookedGuestSurveyDisplayStatusSchema = z.nativeEnum(BookedGuestSurveyDisplayStatus);

export const BillingTypeTermSchema = z.nativeEnum(BillingTypeTerm);

export const BillingTypeTargetForOptionSchema = z.nativeEnum(BillingTypeTargetForOption);

export const BillingTypeTargetSchema = z.nativeEnum(BillingTypeTarget);

export const BedTypeSchema = z.nativeEnum(BedType);

export const AmenitySchema = z.nativeEnum(Amenity);

export const AirHostReservationSyncJobStatusSchema = z.nativeEnum(AirHostReservationSyncJobStatus);

export const BillingTypeTermValidationSchema = z.nativeEnum(BillingTypeTermValidation);

export const AccountTypeHotelSchema = z.nativeEnum(AccountTypeHotel);

export const VoucherListInputSchema: z.ZodObject<Properties<VoucherListInput>> = z.object({
    hotelID: z.string(),
    voucherList: z.array(z.string())
});

export const VoucherIssuedMarkVoucherAsUsedInputSchema: z.ZodObject<Properties<VoucherIssuedMarkVoucherAsUsedInput>> = z.object({
    hotelID: z.string(),
    voucherCode: z.string()
});

export const VoucherIssuedMarkVoucherAsUnUsedInputSchema: z.ZodObject<Properties<VoucherIssuedMarkVoucherAsUnUsedInput>> = z.object({
    hotelID: z.string(),
    voucherCode: z.string()
});

export const VoucherIssuedForCampaignMarkVoucherAsUsedInputSchema: z.ZodObject<Properties<VoucherIssuedForCampaignMarkVoucherAsUsedInput>> = z.object({
    hotelID: z.string(),
    voucherCode: z.string()
});

export const VoucherIssuedForCampaignMarkVoucherAsUnUsedInputSchema: z.ZodObject<Properties<VoucherIssuedForCampaignMarkVoucherAsUnUsedInput>> = z.object({
    hotelID: z.string(),
    voucherCode: z.string()
});

export const VoucherIssuedForCampaignInputSchema: z.ZodObject<Properties<VoucherIssuedForCampaignInput>> = z.object({
    hotelID: z.string(),
    voucherCode: z.string()
});

export const VoucherInputSchema: z.ZodObject<Properties<VoucherInput>> = z.object({
    cinEnd: z.string().nullish(),
    cinStart: z.string().nullish(),
    description: z.string(),
    hotelID: z.string(),
    inSale: z.boolean(),
    intervalPrepDates: z.number().nullish(),
    mainKeyVisual: z.lazy(() => S3ObjectInputSchema),
    maxStockNum: z.number().nullish(),
    name: z.string(),
    saleEnd: z.string().nullish(),
    saleStart: z.string().nullish(),
    saleTypeForTerm: SaleTypeForTermSchema,
    sellingPrice: z.lazy(() => PriceObjectInputSchema),
    soldNumTotal: z.number(),
    voucherID: z.string(),
    voucherLimitType: VoucherLimitTypeSchema,
    voucherPrice: z.lazy(() => PriceObjectInputSchema)
});

export const VoucherI18nInputSchema: z.ZodObject<Properties<VoucherI18nInput>> = z.object({
    description: z.string(),
    hotelID: z.string(),
    lang: LangCodeSchema,
    name: z.string(),
    voucherID: z.string()
});

export const VoucherGiftInfoInputSchema: z.ZodObject<Properties<VoucherGiftInfoInput>> = z.object({
    from: z.string(),
    message: z.string().nullish(),
    password: z.string(),
    to: z.string()
});

export const VoucherForCampaignUserItemInputSchema: z.ZodObject<Properties<VoucherForCampaignUserItemInput>> = z.object({
    guestEmail: z.string().nullish(),
    guestName: z.string(),
    guestTel: z.string()
});

export const VoucherForCampaignInputSchema: z.ZodObject<Properties<VoucherForCampaignInput>> = z.object({
    cinEnd: z.string(),
    cinStart: z.string(),
    description: z.string(),
    hotelID: z.string(),
    inSale: z.boolean(),
    mailTemplate: z.string(),
    mainKeyVisual: z.lazy(() => S3ObjectInputSchema),
    name: z.string(),
    resourceAvailablePrice: z.lazy(() => PriceObjectInputSchema),
    voucherExplanationForHost: z.string(),
    voucherGiftList: z.array(z.lazy(() => VoucherForCampaignUserItemInputSchema)),
    voucherID: z.string(),
    voucherPrice: z.lazy(() => PriceObjectInputSchema)
});

export const TllRoomObjectInputSchema: z.ZodObject<Properties<TllRoomObjectInput>> = z.object({
    chillnnRoomID: z.string().nullish(),
    tllRoomID: z.string()
});

export const TllMasterObjectInputSchema: z.ZodObject<Properties<TllMasterObjectInput>> = z.object({
    defaultPlan: z.string().nullish(),
    rooms: z.array(z.lazy(() => TllRoomObjectInputSchema)),
    tllID: z.string()
});

export const TestEmailInputSchema: z.ZodObject<Properties<TestEmailInput>> = z.object({
    customMessage: z.string(),
    email: z.string(),
    hotelID: z.string(),
    lang: LangCodeSchema
});

export const SubOptionItemInputSchema: z.ZodObject<Properties<SubOptionItemInput>> = z.object({
    endAt: z.string().nullish(),
    isNextMorning: z.boolean().nullish(),
    isShowTimeSchedule: z.boolean().nullish(),
    maxDailyStockNum: z.number(),
    memo: z.string().nullish(),
    name: z.string(),
    price: z.lazy(() => PriceObjectInputSchema),
    startAt: z.string().nullish(),
    subOptionID: z.string().nullish()
});

export const StockHeaderItemInputSchema: z.ZodObject<Properties<StockHeaderItemInput>> = z.object({
    date: z.string()
});

export const SnackSnsIconInputSchema: z.ZodObject<Properties<SnackSnsIconInput>> = z.object({
    snsType: SnackSnsTypeSchema,
    url: z.string()
});

export const SnackSettingsInputSchema: z.ZodObject<Properties<SnackSettingsInput>> = z.object({
    gtmID: z.string().nullish(),
    hotelID: z.string(),
    subDomain: z.string(),
    topPageSnackUUID: z.string().nullish()
});

export const SnackInputSchema: z.ZodObject<Properties<SnackInput>> = z.object({
    availablePlansForHotel: z.array(z.string()).nullish(),
    description: z.string().nullish(),
    hotelID: z.string(),
    isParentTemplate: z.boolean().nullish(),
    isPublished: z.boolean(),
    ownerType: SnackOwnerTypeSchema,
    slug: z.string().nullish(),
    snack: z.lazy(() => S3ObjectInputSchema),
    snackType: SnackTypeSchema,
    thumbnail: z.string(),
    title: z.string(),
    uuid: z.string()
});

export const SnackSnsIconsSettingInputSchema: z.ZodObject<Properties<SnackSnsIconsSettingInput>> = z.object({
    snsColor: SnackSnsColorSchema,
    snsIcons: z.array(z.lazy(() => SnackSnsIconInputSchema))
});

export const SnackBlocksInputSchema: z.ZodObject<Properties<SnackBlocksInput>> = z.object({
    bgImage: z.string().nullish(),
    blocks: z.array(z.lazy(() => SnackBlockItemContainerInputSchema)),
    hotelID: z.string(),
    isShowLanguageSwitcher: z.boolean().nullish(),
    isShowOriginalBgImage: z.boolean().nullish(),
    logoImage: z.string().nullish(),
    snsSetting: z.lazy(() => SnackSnsIconsSettingInputSchema.nullish()),
    uuid: z.string()
});

export const SnackBlocksI18nInputSchema: z.ZodObject<Properties<SnackBlocksI18nInput>> = z.object({
    blocks: z.array(z.lazy(() => SnackBlockItemContainerInputSchema)),
    hotelID: z.string(),
    lang: LangCodeSchema,
    uuid: z.string()
});

export const SnackBlockItemInputSchema: z.ZodObject<Properties<SnackBlockItemInput>> = z.object({
    itemType: SnackBlockItemTypeSchema,
    itemUUID: z.string()
});

export const SnackBlockItemContainerInputSchema: z.ZodObject<Properties<SnackBlockItemContainerInput>> = z.object({
    items: z.array(z.lazy(() => SnackBlockItemInputSchema)),
    title: z.string().nullish(),
    uuid: z.string()
});

export const SiteControllerSettingTllInputSchema: z.ZodObject<Properties<SiteControllerSettingTllInput>> = z.object({
    hotelID: z.string(),
    tll: z.lazy(() => TllMasterObjectInputSchema)
});

export const SiteControllerSettingTemairazuInputSchema: z.ZodObject<Properties<SiteControllerSettingTemairazuInput>> = z.object({
    hotelID: z.string(),
    password: z.string().nullish(),
    setUpRoomPriceByChillnn: z.boolean().nullish()
});

export const SiteControllerSettingNotUsingInputSchema: z.ZodObject<Properties<SiteControllerSettingNotUsingInput>> = z.object({
    hotelID: z.string()
});

export const SiteControllerSettingNeppanInputSchema: z.ZodObject<Properties<SiteControllerSettingNeppanInput>> = z.object({
    hotelID: z.string(),
    password: z.string().nullish(),
    setUpRoomPriceByChillnn: z.boolean().nullish()
});

export const SiteControllerSettingBeds24MasterDataSyncInputSchema: z.ZodObject<Properties<SiteControllerSettingBeds24MasterDataSyncInput>> = z.object({
    beds24AuthenticationApiKey: z.string(),
    beds24AuthenticationPropKey: z.string(),
    hotelID: z.string()
});

export const SiteControllerSettingBeds24InputSchema: z.ZodObject<Properties<SiteControllerSettingBeds24Input>> = z.object({
    beds24AuthenticationApiKey: z.string(),
    beds24AuthenticationPropKey: z.string(),
    beds24AuthenticationPropKeys: z.array(z.string()).nullish(),
    beds24RoomTypeMapping: z.array(z.lazy(() => Beds24RoomTypeMappingItemInputSchema)),
    beds24UseMultiplePropKey: z.boolean().nullish(),
    hotelID: z.string(),
    setUpRoomPriceByChillnn: z.boolean().nullish()
});

export const SiteControllerSettingAirHostReservationSyncStartInputSchema: z.ZodObject<Properties<SiteControllerSettingAirHostReservationSyncStartInput>> = z.object({
    hotelID: z.string()
});

export const SiteControllerSettingAirHostChillnnRoomAndAirHostPricePlanMappingsInputSchema: z.ZodObject<Properties<SiteControllerSettingAirHostChillnnRoomAndAirHostPricePlanMappingsInput>> = z.object({
    airHostSettings: z.lazy(() => AirHostSettingsInputSchema),
    hotelID: z.string()
});

export const SiteControllerSettingAirHostBaseInfoInputSchema: z.ZodObject<Properties<SiteControllerSettingAirHostBaseInfoInput>> = z.object({
    airHostSettings: z.lazy(() => AirHostSettingsInputSchema),
    hotelID: z.string()
});

export const RoomStockObjectInputSchema: z.ZodObject<Properties<RoomStockObjectInput>> = z.object({
    roomID: z.string(),
    stocks: z.array(z.lazy(() => RoomStockDailyItemInputSchema))
});

export const RoomStockInputSchema: z.ZodObject<Properties<RoomStockInput>> = z.object({
    headers: z.array(z.lazy(() => StockHeaderItemInputSchema)),
    hotelID: z.string(),
    items: z.array(z.lazy(() => RoomStockObjectInputSchema))
});

export const RoomStockDailyItemInputSchema: z.ZodObject<Properties<RoomStockDailyItemInput>> = z.object({
    date: z.string(),
    isAvailable: z.boolean(),
    remainNum: z.number()
});

export const RoomQueryKidsItemInputSchema: z.ZodObject<Properties<RoomQueryKidsItemInput>> = z.object({
    age: z.number(),
    asCosleeping: z.boolean().nullish()
});

export const RoomQueryItemInputSchema: z.ZodObject<Properties<RoomQueryItemInput>> = z.object({
    adultNum: z.number(),
    kidsNum: z.array(z.lazy(() => RoomQueryKidsItemInputSchema)),
    uniqueRoomID: z.string()
});

export const RoomPriceRankMastInputSchema: z.ZodObject<Properties<RoomPriceRankMastInput>> = z.object({
    hotelID: z.string(),
    ranks: z.array(z.lazy(() => PriceRankItemInputSchema))
});

export const RoomPriceRankDailyStatusInputSchema: z.ZodObject<Properties<RoomPriceRankDailyStatusInput>> = z.object({
    hotelID: z.string(),
    statuses: z.array(z.lazy(() => PriceRankDailyStatusItemInputSchema))
});

export const RoomPriceObjectInputSchema: z.ZodObject<Properties<RoomPriceObjectInput>> = z.object({
    adultNum: z.number(),
    price: z.lazy(() => PriceObjectInputSchema)
});

export const RoomListInputSchema: z.ZodObject<Properties<RoomListInput>> = z.object({
    hotelID: z.string(),
    rooms: z.array(z.string())
});

export const RoomI18nArticleInputSchema: z.ZodObject<Properties<RoomI18nArticleInput>> = z.object({
    article: z.lazy(() => S3ObjectInputSchema),
    articleTitle: z.string(),
    hotelID: z.string(),
    lang: LangCodeSchema,
    roomID: z.string()
});

export const RoomDummyInputSchema: z.ZodObject<Properties<RoomDummyInput>> = z.object({
    availablePlanIDs: z.array(z.string()),
    capacityAdultMaximum: z.number(),
    capacityKidsMaximum: z.number(),
    capacityPeopleMaximum: z.number(),
    catchCopy: z.string(),
    description: z.string(),
    hotelID: z.string(),
    inSale: z.boolean(),
    isKidsUnavailable: z.boolean(),
    keyVisuals: z.array(z.lazy(() => S3ObjectInputSchema)).nullish(),
    kidsPolicy: z.array(z.lazy(() => KidsPolicyItemInputSchema)).nullish(),
    mainKeyVisual: z.lazy(() => S3ObjectInputSchema),
    maxRoomNum: z.number(),
    name: z.string(),
    roomID: z.string()
});

export const RoomDummyI18nInputSchema: z.ZodObject<Properties<RoomDummyI18nInput>> = z.object({
    catchCopy: z.string(),
    description: z.string(),
    hotelID: z.string(),
    lang: LangCodeSchema,
    name: z.string(),
    roomID: z.string()
});

export const RoomArticleInputSchema: z.ZodObject<Properties<RoomArticleInput>> = z.object({
    article: z.lazy(() => S3ObjectInputSchema),
    articleTitle: z.string(),
    hotelID: z.string(),
    roomID: z.string(),
    tags: z.array(z.string()),
    tagsLocation: z.array(z.string())
});

export const ReservationRequestHandlingInputSchema: z.ZodObject<Properties<ReservationRequestHandlingInput>> = z.object({
    accept: z.boolean(),
    hotelID: z.string(),
    reservationID: z.string()
});

export const ReservationRefundRequestInputSchema: z.ZodObject<Properties<ReservationRefundRequestInput>> = z.object({
    hotelID: z.string(),
    refundPrice: z.number(),
    refundReason: z.string(),
    reservationID: z.string()
});

export const ReservationLocalCancelFeeRejectInputSchema: z.ZodObject<Properties<ReservationLocalCancelFeeRejectInput>> = z.object({
    hotelID: z.string(),
    insufficientAmount: z.number(),
    rejectReason: z.string(),
    reservationID: z.string()
});

export const ReservationLocalCancelFeeAcceptInputSchema: z.ZodObject<Properties<ReservationLocalCancelFeeAcceptInput>> = z.object({
    hotelID: z.string(),
    reservationID: z.string()
});

export const ReservationDetailUpdateNoShowStatusInputSchema: z.ZodObject<Properties<ReservationDetailUpdateNoShowStatusInput>> = z.object({
    hotelID: z.string(),
    reservationID: z.string(),
    statusNoShow: z.boolean()
});

export const ReservationDetailUpdateMailMagazineStatusInputSchema: z.ZodObject<Properties<ReservationDetailUpdateMailMagazineStatusInput>> = z.object({
    hotelID: z.string(),
    reservationID: z.string(),
    statusMailMagazine: z.boolean()
});

export const ReservationDetailUpdateIssuedReceiptStatusInputSchema: z.ZodObject<Properties<ReservationDetailUpdateIssuedReceiptStatusInput>> = z.object({
    hotelID: z.string(),
    reservationID: z.string(),
    statusReceiptIssued: z.boolean()
});

export const ReservationDetailUpdateHostMemoInputSchema: z.ZodObject<Properties<ReservationDetailUpdateHostMemoInput>> = z.object({
    hostMemo: z.string(),
    hotelID: z.string(),
    reservationID: z.string()
});

export const ReservationDetailIssueReceiptInputSchema: z.ZodObject<Properties<ReservationDetailIssueReceiptInput>> = z.object({
    address: z.string().nullish(),
    hotelID: z.string(),
    reservationID: z.string()
});

export const ReservationCancelInputSchema: z.ZodObject<Properties<ReservationCancelInput>> = z.object({
    canceledPrice: z.number(),
    hotelID: z.string(),
    reservationID: z.string()
});

export const ReservationCancelFeeChargeInputSchema: z.ZodObject<Properties<ReservationCancelFeeChargeInput>> = z.object({
    chargePrice: z.number(),
    hotelID: z.string(),
    reservationID: z.string()
});

export const ReceiptSettingInputSchema: z.ZodObject<Properties<ReceiptSettingInput>> = z.object({
    addressee: z.string(),
    hotelID: z.string(),
    id: z.string()
});

export const ReOnboardingRequestInputSchema: z.ZodObject<Properties<ReOnboardingRequestInput>> = z.object({
    hotelID: z.string(),
    message: z.string(),
    updatedEmail: z.string().nullish()
});

export const QuestionItemInputSchema: z.ZodObject<Properties<QuestionItemInput>> = z.object({
    options: z.array(z.string()).nullish(),
    question: z.string(),
    questionID: z.string(),
    questionType: QuestionTypeSchema,
    required: z.boolean().nullish()
});

export const ProTicketPurchaseInputSchema: z.ZodObject<Properties<ProTicketPurchaseInput>> = z.object({
    hotelID: z.string(),
    isStopRecurringProBilling: z.boolean(),
    proTicketID: z.string()
});

export const PriceRankRoomItemInputSchema: z.ZodObject<Properties<PriceRankRoomItemInput>> = z.object({
    prices: z.array(z.lazy(() => RoomPriceObjectInputSchema)).nullish(),
    roomID: z.string(),
    roomName: z.string()
});

export const PriceRankItemInputSchema: z.ZodObject<Properties<PriceRankItemInput>> = z.object({
    color: z.string(),
    isStopSelling: z.boolean().nullish(),
    name: z.string(),
    priceRankID: z.string(),
    rooms: z.array(z.lazy(() => PriceRankRoomItemInputSchema)).nullish()
});

export const PriceRankDailyStatusItemInputSchema: z.ZodObject<Properties<PriceRankDailyStatusItemInput>> = z.object({
    date: z.string(),
    hotelID: z.string(),
    priceRankID: z.string().nullish()
});

export const PlanStockObjectInputSchema: z.ZodObject<Properties<PlanStockObjectInput>> = z.object({
    planID: z.string(),
    stocks: z.array(z.lazy(() => PlanStockDailyItemInputSchema))
});

export const PlanStockInputSchema: z.ZodObject<Properties<PlanStockInput>> = z.object({
    headers: z.array(z.lazy(() => StockHeaderItemInputSchema)),
    hotelID: z.string(),
    items: z.array(z.lazy(() => PlanStockObjectInputSchema))
});

export const PlanStockDailyItemInputSchema: z.ZodObject<Properties<PlanStockDailyItemInput>> = z.object({
    date: z.string(),
    isAvailable: z.boolean(),
    remainNum: z.number()
});

export const PlanListInputSchema: z.ZodObject<Properties<PlanListInput>> = z.object({
    hotelID: z.string(),
    plans: z.array(z.string())
});

export const StaticRoomPriceParamsInputSchema: z.ZodObject<Properties<StaticRoomPriceParamsInput>> = z.object({
    staticRoomPrices: z.array(z.lazy(() => PriceRankRoomItemInputSchema))
});

export const ShortStayParamsInputSchema: z.ZodObject<Properties<ShortStayParamsInput>> = z.object({
    maximumStayDates: z.number()
});

export const PlanI18nArticleInputSchema: z.ZodObject<Properties<PlanI18nArticleInput>> = z.object({
    article: z.lazy(() => S3ObjectInputSchema),
    articleTitle: z.string(),
    hotelID: z.string(),
    lang: LangCodeSchema,
    planID: z.string()
});

export const PlanCustomMailSettingInputSchema: z.ZodObject<Properties<PlanCustomMailSettingInput>> = z.object({
    forReservation: z.lazy(() => BasicCustomMailForReservationOverrideInputSchema),
    id: z.string(),
    planID: z.string()
});

export const PlanCustomMailSettingI18nInputSchema: z.ZodObject<Properties<PlanCustomMailSettingI18nInput>> = z.object({
    forReservation: z.lazy(() => BasicCustomMailForReservationOverrideInputSchema),
    id: z.string(),
    lang: LangCodeSchema,
    planID: z.string()
});

export const PlanArticleInputSchema: z.ZodObject<Properties<PlanArticleInput>> = z.object({
    article: z.lazy(() => S3ObjectInputSchema),
    articleTitle: z.string(),
    hotelID: z.string(),
    planID: z.string(),
    tags: z.array(z.string()),
    tagsLocation: z.array(z.string())
});

export const PlainWidgetItemInputSchema: z.ZodObject<Properties<PlainWidgetItemInput>> = z.object({
    contentID: z.string(),
    title: z.string(),
    widgetID: z.string(),
    widgetType: PlainWidgetTypeSchema
});

export const PlainWidgetInputSchema: z.ZodObject<Properties<PlainWidgetInput>> = z.object({
    hotelID: z.string(),
    widgetItems: z.array(z.lazy(() => PlainWidgetItemInputSchema))
});

export const PlainWidgetI18nInputSchema: z.ZodObject<Properties<PlainWidgetI18nInput>> = z.object({
    hotelID: z.string(),
    lang: LangCodeSchema,
    widgetItems: z.array(z.lazy(() => PlainWidgetItemInputSchema))
});

export const PaymentDepositAccountInputSchema: z.ZodObject<Properties<PaymentDepositAccountInput>> = z.object({
    bankAccountHolderName: z.string(),
    bankAccountNumber: z.string(),
    bankAccountType: z.string(),
    bankBranchCode: z.string(),
    bankCode: z.string(),
    hotelID: z.string(),
    minimumTransferAmount: z.number()
});

export const PaymentCreditInputSchema: z.ZodObject<Properties<PaymentCreditInput>> = z.object({
    hotelID: z.string(),
    paymentToken: z.string()
});

export const OverSiteControllerPeoplePriceInputSchema: z.ZodObject<Properties<OverSiteControllerPeoplePriceInput>> = z.object({
    price: z.lazy(() => PriceObjectInputSchema),
    upperNum: z.number()
});

export const OverSiteControllerPeopleNumInputSchema: z.ZodObject<Properties<OverSiteControllerPeopleNumInput>> = z.object({
    availableWeekDays: z.array(DayOfTheWeekSchema),
    prices: z.array(z.lazy(() => OverSiteControllerPeoplePriceInputSchema))
});

export const OptionStockObjectInputSchema: z.ZodObject<Properties<OptionStockObjectInput>> = z.object({
    optionID: z.string(),
    stocks: z.array(z.lazy(() => OptionStockDailyItemInputSchema)),
    subOptionID: z.string().nullish()
});

export const OptionStockInputSchema: z.ZodObject<Properties<OptionStockInput>> = z.object({
    headers: z.array(z.lazy(() => StockHeaderItemInputSchema)),
    hotelID: z.string(),
    items: z.array(z.lazy(() => OptionStockObjectInputSchema))
});

export const OptionStockDailyItemInputSchema: z.ZodObject<Properties<OptionStockDailyItemInput>> = z.object({
    date: z.string(),
    isAvailable: z.boolean(),
    remainNum: z.number()
});

export const OptionPmsItemFromReservationCommentInputSchema: z.ZodObject<Properties<OptionPmsItemFromReservationCommentInput>> = z.object({
    comment: z.string(),
    hotelID: z.string(),
    reservationID: z.string(),
    uniqueID: z.string()
});

export const OptionPmsItemFromDirectCommentInputSchema: z.ZodObject<Properties<OptionPmsItemFromDirectCommentInput>> = z.object({
    cardID: z.string(),
    comment: z.string(),
    date: z.string(),
    hotelID: z.string(),
    optionID: z.string(),
    subOptionID: z.string().nullish()
});

export const OptionPmsItemCreateInputSchema: z.ZodObject<Properties<OptionPmsItemCreateInput>> = z.object({
    amount: z.number(),
    comment: z.string().nullish(),
    date: z.string(),
    guestName: z.string(),
    guestTel: z.string().nullish(),
    hotelID: z.string(),
    optionID: z.string(),
    subOptionID: z.string().nullish()
});

export const OptionPmsItemCancelInputSchema: z.ZodObject<Properties<OptionPmsItemCancelInput>> = z.object({
    cardID: z.string(),
    date: z.string(),
    hotelID: z.string(),
    optionID: z.string(),
    subOptionID: z.string().nullish()
});

export const OptionPmsColorItemInputSchema: z.ZodObject<Properties<OptionPmsColorItemInput>> = z.object({
    color: z.string(),
    hotelID: z.string(),
    optionID: z.string()
});

export const OptionListInputSchema: z.ZodObject<Properties<OptionListInput>> = z.object({
    hotelID: z.string(),
    options: z.array(z.string())
});

export const OptionInputSchema: z.ZodObject<Properties<OptionInput>> = z.object({
    availablePlanIDs: z.array(z.string()),
    billingTypeTarget: BillingTypeTargetForOptionSchema,
    billingTypeTerm: BillingTypeTermSchema,
    cancelPolicy: z.array(z.lazy(() => CancelPolicyItemInputSchema)),
    description: z.string(),
    hotelID: z.string(),
    inSale: z.boolean(),
    isDateTabbedTimeSelectionEnabled: z.boolean(),
    isHolidayStayable: z.boolean().nullish(),
    isNextMorning: z.boolean(),
    isNotDiscountTarget: z.boolean().nullish(),
    keyVisuals: z.array(z.lazy(() => S3ObjectInputSchema)),
    mainKeyVisual: z.lazy(() => S3ObjectInputSchema),
    maxBuyableNumPerTarget: z.number().nullish(),
    maxDailyStockNum: z.number().nullish(),
    maxStockNum: z.number().nullish(),
    minimumBuyableNumPerTarget: z.number().nullish(),
    multiSubOptionSelectable: z.boolean(),
    name: z.string(),
    optionID: z.string(),
    optionType: OptionTypeSchema,
    price: z.lazy(() => PriceObjectInputSchema),
    requiredPrepMillisecond: z.number(),
    saleEnd: z.string().nullish(),
    saleStart: z.string().nullish(),
    saleStartBeforeDate: z.number().nullish(),
    saleTypeForPlan: SaleTypeForPlanSchema,
    saleTypeForTerm: SaleTypeForTermSchema,
    stayableDayOfTheWeek: z.array(DayOfTheWeekSchema),
    stayableEnd: z.string().nullish(),
    stayableStart: z.string().nullish(),
    subOptions: z.array(z.lazy(() => SubOptionItemInputSchema)).nullish(),
    useAsSubOption: z.boolean()
});

export const OptionI18nInputSchema: z.ZodObject<Properties<OptionI18nInput>> = z.object({
    description: z.string(),
    hotelID: z.string(),
    lang: LangCodeSchema,
    name: z.string(),
    optionID: z.string(),
    subOptions: z.array(z.lazy(() => SubOptionItemInputSchema)).nullish()
});

export const MagazineMediaPublicationRequestInputSchema: z.ZodObject<Properties<MagazineMediaPublicationRequestInput>> = z.object({
    hotelID: z.string()
});

export const MagazineAnalyticsSettingInputSchema: z.ZodObject<Properties<MagazineAnalyticsSettingInput>> = z.object({
    gtmAvailable: z.boolean(),
    gtmID: z.string().nullish(),
    hotelID: z.string(),
    pixelAvailable: z.boolean(),
    pixelID: z.string().nullish()
});

export const LongStayParamsInputSchema: z.ZodObject<Properties<LongStayParamsInput>> = z.object({
    minimumStayDates: z.number()
});

export const ReservationDetailUpdateMailResendRequestInputSchema: z.ZodObject<Properties<ReservationDetailUpdateMailResendRequestInput>> = z.object({
    guestEmail: z.string().nullish(),
    hotelID: z.string(),
    langCode: LangCodeSchema.nullish(),
    reservationID: z.string()
});

export const InvoiceSystemSettingsInputSchema: z.ZodObject<Properties<InvoiceSystemSettingsInput>> = z.object({
    hotelID: z.string(),
    id: z.string(),
    registrationCode: z.string().nullish(),
    registrationStatus: RegistrationStatusTypeSchema
});

export const ImageInputSchema: z.ZodObject<Properties<ImageInput>> = z.object({
    image: z.lazy(() => S3ObjectInputSchema),
    ownerID: z.string()
});

export const HotelTemplateSettingsUpdateInputSchema: z.ZodObject<Properties<HotelTemplateSettingsUpdateInput>> = z.object({
    hotelID: z.string(),
    hotelTemplateType: HotelTemplateTypeSchema
});

export const HotelTemplateSettingsSkipInputSchema: z.ZodObject<Properties<HotelTemplateSettingsSkipInput>> = z.object({
    hotelID: z.string()
});

export const HotelTemplateSettingsResetInputSchema: z.ZodObject<Properties<HotelTemplateSettingsResetInput>> = z.object({
    hotelID: z.string()
});

export const HotelSetUpInputSchema: z.ZodObject<Properties<HotelSetUpInput>> = z.object({
    hotelEmailAddress: z.string(),
    hotelName: z.string(),
    totalRoomNum: z.number()
});

export const HotelPolicyI18nInputSchema: z.ZodObject<Properties<HotelPolicyI18nInput>> = z.object({
    additionalFees: z.array(z.lazy(() => AdditionalFeeItemInputSchema)),
    hotelID: z.string(),
    hotelInfo: z.array(z.lazy(() => HotelInfoItemInputSchema)),
    id: z.string(),
    lang: LangCodeSchema,
    questions: z.array(z.lazy(() => QuestionItemInputSchema))
});

export const HotelNotificationSettingInputSchema: z.ZodObject<Properties<HotelNotificationSettingInput>> = z.object({
    ecNotificationEmails: z.array(z.string()),
    hotelID: z.string(),
    id: z.string(),
    paymentNotificationEmails: z.array(z.string()),
    reservationNotificationEmails: z.array(z.string())
});

export const S3ObjectInputSchema: z.ZodObject<Properties<S3ObjectInput>> = z.object({
    bucket: z.string(),
    fileName: z.string().nullish(),
    key: z.string(),
    mimeType: z.string().nullish(),
    region: z.string()
});

export const PlainSettingInputSchema: z.ZodObject<Properties<PlainSettingInput>> = z.object({
    backgroundImage: z.lazy(() => S3ObjectInputSchema.nullish()),
    backgroundType: PlainBackgroundTypeSchema,
    colorBackground: z.string(),
    colorFont: z.string(),
    colorPrimary: z.string(),
    domainName: z.string().nullish(),
    fontFamily: PlainFontFamilySchema.nullish(),
    gtmID: z.string().nullish(),
    hotelID: z.string(),
    isShowHotelCatchCopy: z.boolean(),
    isShowHotelKeyVisual: z.boolean(),
    isShowHotelLogo: z.boolean(),
    isShowHotelName: z.boolean(),
    isShowMagazineAbout: z.boolean().nullish(),
    isShowMagazinePlan: z.boolean().nullish(),
    isShowMagazineRoom: z.boolean().nullish(),
    logoImage: z.lazy(() => S3ObjectInputSchema.nullish()),
    logoSize: PlainSizeTypeSchema.nullish(),
    reservationComponentType: PlainReservationComponentTypeSchema.nullish(),
    reservationComponentViewerOrder: z.array(PlainReservationComponentViewerTypeSchema).nullish(),
    widgetDecoration: PlainWidgetDecorationSchema.nullish()
});

export const HotelInfoItemInputSchema: z.ZodObject<Properties<HotelInfoItemInput>> = z.object({
    description: z.string(),
    title: z.string()
});

export const HotelI18nArticleInputSchema: z.ZodObject<Properties<HotelI18nArticleInput>> = z.object({
    article: z.lazy(() => S3ObjectInputSchema),
    hotelID: z.string(),
    lang: LangCodeSchema
});

export const HotelDisplaySettingsInputSchema: z.ZodObject<Properties<HotelDisplaySettingsInput>> = z.object({
    bookedGuestSurveyDisplayStatus: BookedGuestSurveyDisplayStatusSchema,
    hotelID: z.string(),
    id: z.string(),
    isShowCheckInOutTime: z.boolean()
});

export const HotelArticleInputSchema: z.ZodObject<Properties<HotelArticleInput>> = z.object({
    article: z.lazy(() => S3ObjectInputSchema),
    hotelID: z.string(),
    tags: z.array(z.string()),
    tagsLocation: z.array(z.string())
});

export const HpbSettingsInputSchema: z.ZodObject<Properties<HpbSettingsInput>> = z.object({
    domainName: z.string(),
    hotelID: z.string(),
    ownerType: HpbOwnerTypeSchema
});

export const HpbPageUpdateInputSchema: z.ZodObject<Properties<HpbPageUpdateInput>> = z.object({
    description: z.string().nullish(),
    hotelID: z.string(),
    slug: z.string().nullish(),
    staticPageType: HpbPageTypeSchema.nullish(),
    studio: z.lazy(() => S3ObjectInputSchema),
    thumbnail: z.string(),
    title: z.string(),
    uuid: z.string()
});

export const HpbPageCreateInputSchema: z.ZodObject<Properties<HpbPageCreateInput>> = z.object({
    description: z.string().nullish(),
    hotelID: z.string(),
    slug: z.string().nullish(),
    staticPageType: HpbPageTypeSchema.nullish(),
    studio: z.lazy(() => S3ObjectInputSchema),
    thumbnail: z.string(),
    title: z.string()
});

export const GuestPageVisibilitySettingsInputSchema: z.ZodObject<Properties<GuestPageVisibilitySettingsInput>> = z.object({
    hotelID: z.string(),
    id: z.string(),
    magazineVisibility: GuestPageVisibilityModeSchema,
    plainVisibility: GuestPageVisibilityModeSchema,
    snackVisibility: GuestPageVisibilityModeSchema
});

export const GoogleFreeBookingLinksSettingsUpdateHotelTypeInputSchema: z.ZodObject<Properties<GoogleFreeBookingLinksSettingsUpdateHotelTypeInput>> = z.object({
    hotelID: z.string(),
    hotelType: GoogleFreeBookingLinksHotelTypeSchema
});

export const GoogleFreeBookingLinksSettingsInputSchema: z.ZodObject<Properties<GoogleFreeBookingLinksSettingsInput>> = z.object({
    address: z.lazy(() => GoogleFreeBookingLinksAddressInputSchema),
    capacity: z.number().nullish(),
    chillnnGuestPageType: ChillnnGuestPageTypeSchema,
    createdAt: z.number(),
    defaultPlanID: z.string().nullish(),
    defaultRoomID: z.string().nullish(),
    geoLocation: z.lazy(() => GeoLocationInputSchema),
    hotelID: z.string(),
    hotelName: z.string(),
    hotelType: GoogleFreeBookingLinksHotelTypeSchema,
    id: z.string(),
    notConnectedReason: z.string().nullish(),
    phoneNumbers: z.array(z.lazy(() => GoogleFreeBookingLinksPhoneNumberInputSchema)),
    status: GoogleFreeBookingLinksConnectionStatusSchema,
    updatedAt: z.number(),
    webSite: z.string()
});

export const GoogleFreeBookingLinksSettingsI18nInputSchema: z.ZodObject<Properties<GoogleFreeBookingLinksSettingsI18nInput>> = z.object({
    address: z.lazy(() => GoogleFreeBookingLinksAddressInputSchema),
    hotelID: z.string(),
    hotelName: z.string(),
    lang: LangCodeSchema
});

export const GoogleFreeBookingLinksPhoneNumberInputSchema: z.ZodObject<Properties<GoogleFreeBookingLinksPhoneNumberInput>> = z.object({
    phoneNumber: z.string(),
    phoneType: GoogleFreeBookingLinksPhoneTypeSchema
});

export const GoogleFreeBookingLinksAddressInputSchema: z.ZodObject<Properties<GoogleFreeBookingLinksAddressInput>> = z.object({
    addr1: z.string(),
    addr2: z.string(),
    addr3: z.string().nullish(),
    city: z.string(),
    country: z.string(),
    postalCode: z.string(),
    province: z.string()
});

export const GeoLocationInputSchema: z.ZodObject<Properties<GeoLocationInput>> = z.object({
    lat: z.number(),
    lon: z.number()
});

export const EmailTemplateReservationInputSchema: z.ZodObject<Properties<EmailTemplateReservationInput>> = z.object({
    atCanceled: z.string().nullish(),
    atCin: z.string().nullish(),
    atCreated: z.string().nullish(),
    atUpdated: z.string().nullish()
});

export const PlanI18nInputSchema: z.ZodObject<Properties<PlanI18nInput>> = z.object({
    emailTemplateReservation: z.lazy(() => EmailTemplateReservationInputSchema.nullish()),
    hotelID: z.string(),
    lang: LangCodeSchema,
    mainTarget: z.string().nullish(),
    name: z.string(),
    planID: z.string(),
    questions: z.array(z.lazy(() => QuestionItemInputSchema))
});

export const EcReceiptEmailResendInputSchema: z.ZodObject<Properties<EcReceiptEmailResendInput>> = z.object({
    guestEmail: z.string().nullish(),
    hotelID: z.string(),
    receiptID: z.string()
});

export const DiscountOrdinaryI18nInputSchema: z.ZodObject<Properties<DiscountOrdinaryI18nInput>> = z.object({
    description: z.string(),
    discountID: z.string(),
    hotelID: z.string(),
    lang: LangCodeSchema,
    name: z.string()
});

export const DiscountMultiI18nInputSchema: z.ZodObject<Properties<DiscountMultiI18nInput>> = z.object({
    description: z.string(),
    discountID: z.string(),
    hotelID: z.string(),
    lang: LangCodeSchema,
    name: z.string()
});

export const PriceObjectInputSchema: z.ZodObject<Properties<PriceObjectInput>> = z.object({
    amount: z.number(),
    currencyType: CurrencyTypeSchema
});

export const PlanInputSchema: z.ZodObject<Properties<PlanInput>> = z.object({
    availableDiscountIDs: z.array(z.string()),
    availableOptionIDs: z.array(z.string()),
    availableRoomIDs: z.array(z.string()),
    billingTypeTarget: BillingTypeTargetSchema,
    billingTypeTerm: BillingTypeTermSchema,
    cancelPolicy: z.array(z.lazy(() => CancelPolicyItemInputSchema)).nullish(),
    checkInAvailableDayOfTheWeek: z.array(DayOfTheWeekSchema).nullish(),
    checkInEnd: z.string(),
    checkInStart: z.string(),
    checkOut: z.string(),
    coSleepingKidsPrice: z.lazy(() => PriceObjectInputSchema.nullish()),
    defaultDiscountID: z.string().nullish(),
    doNotCountKidsAsStock: z.boolean(),
    emailTemplateReservation: z.lazy(() => EmailTemplateReservationInputSchema.nullish()),
    hotelID: z.string(),
    inSale: z.boolean(),
    includedMeals: z.array(MealTypeSchema).nullish(),
    isChangeOnlyOption: z.boolean(),
    isCoSleepingKidsPriceActive: z.boolean(),
    isDayTrip: z.boolean(),
    isHiddenHotelQuestions: z.boolean(),
    isHolidayCheckInAvailable: z.boolean().nullish(),
    isHolidayStayable: z.boolean().nullish(),
    isNoAddressNeeded: z.boolean(),
    isPrivate: z.boolean(),
    isRequest: z.boolean(),
    isRoomPriceFree: z.boolean(),
    isSCConnected: z.boolean().nullish(),
    isShowRoomForGuest: z.boolean(),
    isUncancelable: z.boolean(),
    isUnchangeable: z.boolean(),
    keyVisuals: z.array(z.lazy(() => S3ObjectInputSchema)),
    kidsPolicy: z.array(z.lazy(() => KidsPolicyItemInputSchema)).nullish(),
    longStayParams: z.lazy(() => LongStayParamsInputSchema.nullish()),
    mainKeyVisual: z.lazy(() => S3ObjectInputSchema),
    mainTarget: z.string().nullish(),
    maxDailyStockNum: z.number().nullish(),
    maxPeopleNumPerRoom: z.number().nullish(),
    maxRoomNum: z.number().nullish(),
    maxStockNum: z.number().nullish(),
    minRoomNum: z.number().nullish(),
    minimumPeopleNumPerRoom: z.number().nullish(),
    name: z.string(),
    notSendCinMail: z.boolean(),
    onlyUseCreditPayment: z.boolean(),
    onlyUseLocalPayment: z.boolean(),
    planID: z.string(),
    price: z.lazy(() => PriceObjectInputSchema),
    questions: z.array(z.lazy(() => QuestionItemInputSchema)),
    requiredOptionGroupIDs: z.array(z.string()),
    requiredOptionIDs: z.array(z.string()),
    requiredPrepMillisecond: z.number(),
    roomChangeDisable: z.boolean(),
    saleEnd: z.string().nullish(),
    saleEndTime: z.string().nullish(),
    saleStart: z.string().nullish(),
    saleStartBeforeDate: z.number().nullish(),
    saleStartTime: z.string().nullish(),
    saleTypeForTerm: SaleTypeForTermSchema,
    shortStayParams: z.lazy(() => ShortStayParamsInputSchema.nullish()),
    staticPriceParams: z.lazy(() => StaticRoomPriceParamsInputSchema.nullish()),
    stayableDayOfTheWeek: z.array(DayOfTheWeekSchema).nullish(),
    stayableEnd: z.string().nullish(),
    stayableStart: z.string().nullish(),
    stockTypeTarget: StockTypeTargetSchema.nullish(),
    stockTypeTerm: StockTypeTermSchema.nullish()
});

export const LongTermStayDiscountObjectInputSchema: z.ZodObject<Properties<LongTermStayDiscountObjectInput>> = z.object({
    discountType: DiscountTypeSchema,
    includeSmallestNights: z.number(),
    ratio: z.number().nullish(),
    static: z.lazy(() => PriceObjectInputSchema.nullish()),
    staticTargetType: DiscountTargetTypeSchema.nullish()
});

export const KidsPolicyItemInputSchema: z.ZodObject<Properties<KidsPolicyItemInput>> = z.object({
    kidsDiscountType: KidsPolicyTypeSchema,
    kidsMaxAge: z.number(),
    ratio: z.number().nullish(),
    static: z.lazy(() => PriceObjectInputSchema.nullish())
});

export const KidsCosleepingPolicyInputSchema: z.ZodObject<Properties<KidsCosleepingPolicyInput>> = z.object({
    isActive: z.boolean(),
    kidsDiscountType: KidsCosleepingPolicyTypeSchema,
    kidsMaxAge: z.number(),
    ratio: z.number().nullish(),
    static: z.lazy(() => PriceObjectInputSchema.nullish())
});

export const DiscountOrdinaryInputSchema: z.ZodObject<Properties<DiscountOrdinaryInput>> = z.object({
    description: z.string(),
    discountCode: z.string(),
    discountID: z.string(),
    discountPriceTotalLimit: z.lazy(() => PriceObjectInputSchema.nullish()),
    discountType: DiscountTypeSchema,
    hotelID: z.string(),
    inSale: z.boolean(),
    isAdditionalFeeDiscountEligible: z.boolean().nullish(),
    isOptionDiscountEligible: z.boolean().nullish(),
    isPlanDiscountEligible: z.boolean().nullish(),
    isRoomDiscountEligible: z.boolean().nullish(),
    isUncancelable: z.boolean(),
    name: z.string(),
    ratio: z.number().nullish(),
    resourceLowestPrice: z.lazy(() => PriceObjectInputSchema),
    saleEnd: z.string().nullish(),
    saleStart: z.string().nullish(),
    saleTypeForPlan: SaleTypeForPlanSchema,
    saleTypeForTerm: SaleTypeForTermSchema,
    static: z.lazy(() => PriceObjectInputSchema.nullish()),
    staticTargetType: DiscountTargetTypeSchema,
    staticTermType: DiscountTermTypeSchema,
    stayableDayOfTheWeek: z.array(DayOfTheWeekSchema).nullish(),
    stayableEnd: z.string().nullish(),
    stayableStart: z.string().nullish()
});

export const DiscountMultiInputSchema: z.ZodObject<Properties<DiscountMultiInput>> = z.object({
    description: z.string(),
    discountCode: z.string(),
    discountID: z.string(),
    discountPriceTotalLimit: z.lazy(() => PriceObjectInputSchema.nullish()),
    hotelID: z.string(),
    inSale: z.boolean(),
    isUncancelable: z.boolean(),
    multiDiscounts: z.array(z.string()),
    name: z.string(),
    saleEnd: z.string().nullish(),
    saleStart: z.string().nullish(),
    saleTypeForPlan: SaleTypeForPlanSchema,
    saleTypeForTerm: SaleTypeForTermSchema,
    stayableDayOfTheWeek: z.array(DayOfTheWeekSchema).nullish(),
    stayableEnd: z.string().nullish(),
    stayableStart: z.string().nullish()
});

export const DiscountLongTermInputSchema: z.ZodObject<Properties<DiscountLongTermInput>> = z.object({
    description: z.string(),
    discountCode: z.string(),
    discountID: z.string(),
    discountPriceTotalLimit: z.lazy(() => PriceObjectInputSchema.nullish()),
    hotelID: z.string(),
    inSale: z.boolean(),
    isUncancelable: z.boolean(),
    longTermStayDiscountObject: z.array(z.lazy(() => LongTermStayDiscountObjectInputSchema)),
    name: z.string(),
    resourceLowestPrice: z.lazy(() => PriceObjectInputSchema),
    roomConditionType: DiscountRoomConditionTypeSchema.nullish(),
    saleEnd: z.string().nullish(),
    saleStart: z.string().nullish(),
    saleTypeForPlan: SaleTypeForPlanSchema,
    saleTypeForTerm: SaleTypeForTermSchema,
    stayableDayOfTheWeek: z.array(DayOfTheWeekSchema).nullish(),
    stayableEnd: z.string().nullish(),
    stayableStart: z.string().nullish()
});

export const DiscountLongTermI18nInputSchema: z.ZodObject<Properties<DiscountLongTermI18nInput>> = z.object({
    description: z.string(),
    discountID: z.string(),
    hotelID: z.string(),
    lang: LangCodeSchema,
    name: z.string()
});

export const CustomMailSettingTestMailInputSchema: z.ZodObject<Properties<CustomMailSettingTestMailInput>> = z.object({
    customMessage: z.string(),
    id: z.string(),
    langCode: LangCodeSchema,
    mailAddress: z.string()
});

export const CustomEmailShoppingInputSchema: z.ZodObject<Properties<CustomEmailShoppingInput>> = z.object({
    atCreated: z.string().nullish()
});

export const CustomEmailSettingInputSchema: z.ZodObject<Properties<CustomEmailSettingInput>> = z.object({
    id: z.string(),
    mailFooterExternalLink: z.string().nullish(),
    requestReservation: z.lazy(() => CustomEmailRequestReservationInputSchema),
    reservation: z.lazy(() => CustomEmailReservationInputSchema),
    shopping: z.lazy(() => CustomEmailShoppingInputSchema)
});

export const CustomEmailSettingI18nInputSchema: z.ZodObject<Properties<CustomEmailSettingI18nInput>> = z.object({
    hotelID: z.string(),
    id: z.string(),
    lang: LangCodeSchema,
    requestReservation: z.lazy(() => CustomEmailRequestReservationInputSchema),
    reservation: z.lazy(() => CustomEmailReservationInputSchema),
    shopping: z.lazy(() => CustomEmailShoppingInputSchema)
});

export const CustomEmailReservationInputSchema: z.ZodObject<Properties<CustomEmailReservationInput>> = z.object({
    atCanceled: z.string().nullish(),
    atCin: z.string().nullish(),
    atCreated: z.string().nullish(),
    atUpdated: z.string().nullish()
});

export const CustomEmailRequestReservationInputSchema: z.ZodObject<Properties<CustomEmailRequestReservationInput>> = z.object({
    atConfirmed: z.string().nullish(),
    atDeclined: z.string().nullish(),
    atRequest: z.string().nullish()
});

export const ContactUpdateInputSchema: z.ZodObject<Properties<ContactUpdateInput>> = z.object({
    contactGenre: ContactGenreSchema,
    contactID: z.string(),
    hotelID: z.string(),
    message: z.lazy(() => ContactMessageItemInputSchema),
    reservationID: z.string().nullish()
});

export const ContactMessageItemInputSchema: z.ZodObject<Properties<ContactMessageItemInput>> = z.object({
    images: z.array(z.lazy(() => S3ObjectInputSchema)).nullish(),
    message: z.string().nullish(),
    relatedURLs: z.array(z.string()),
    senderType: ContactMessageSenderTypeSchema
});

export const ContactCreateInputSchema: z.ZodObject<Properties<ContactCreateInput>> = z.object({
    contactGenre: ContactGenreSchema,
    hostReplyToMail: z.string().nullish(),
    hotelID: z.string(),
    message: z.lazy(() => ContactMessageItemInputSchema),
    reservationID: z.string().nullish(),
    title: z.string()
});

export const ChillnnRoomAndAirHostPricePlanMappingItemInputSchema: z.ZodObject<Properties<ChillnnRoomAndAirHostPricePlanMappingItemInput>> = z.object({
    airHostPlanID: z.string(),
    airHostRoomCheckInTime: z.string(),
    airHostRoomCheckOutTime: z.string(),
    airHostRoomTypeID: z.string(),
    chillnnRoomID: z.string()
});

export const CancelPolicyItemInputSchema: z.ZodObject<Properties<CancelPolicyItemInput>> = z.object({
    beforeDays: z.number(),
    chargeRatio: z.number()
});

export const ChurnInfoSchema: z.ZodObject<Properties<ChurnInfo>> = z.object({
    comment: z.string().nullish(),
    reason: z.string()
});

export const BillingStatusUpdateInputSchema: z.ZodObject<Properties<BillingStatusUpdateInput>> = z.object({
    churnInfo: ChurnInfoSchema.nullish(),
    defaultBasicBillingTicketID: z.string().nullish(),
    defaultProBillingTicketID: z.string().nullish(),
    hotelID: z.string(),
    isStopRecurringBasicBilling: z.boolean(),
    isStopRecurringProBilling: z.boolean()
});

export const Beds24RoomTypeMappingItemInputSchema: z.ZodObject<Properties<Beds24RoomTypeMappingItemInput>> = z.object({
    beds24AuthenticationPropKey: z.string().nullish(),
    beds24roomID: z.string(),
    roomID: z.string().nullish()
});

export const BedItemInputSchema: z.ZodObject<Properties<BedItemInput>> = z.object({
    bedNum: z.number(),
    bedType: BedTypeSchema
});

export const BasicCustomMailSettingInputSchema: z.ZodObject<Properties<BasicCustomMailSettingInput>> = z.object({
    forReservation: z.lazy(() => BasicCustomMailForReservationInputSchema),
    forShopping: z.lazy(() => BasicCustomMailForShoppingInputSchema),
    id: z.string(),
    mailFooterExternalLink: z.string().nullish()
});

export const BasicCustomMailSettingI18nInputSchema: z.ZodObject<Properties<BasicCustomMailSettingI18nInput>> = z.object({
    forReservation: z.lazy(() => BasicCustomMailForReservationInputSchema),
    forShopping: z.lazy(() => BasicCustomMailForShoppingInputSchema),
    id: z.string(),
    lang: LangCodeSchema
});

export const BasicCustomMailRequiredItemOverrideInputSchema: z.ZodObject<Properties<BasicCustomMailRequiredItemOverrideInput>> = z.object({
    override: z.boolean(),
    text: z.string()
});

export const BasicCustomMailOptionalItemOverrideInputSchema: z.ZodObject<Properties<BasicCustomMailOptionalItemOverrideInput>> = z.object({
    override: z.boolean(),
    shouldSendEmail: z.boolean(),
    text: z.string()
});

export const BasicCustomMailItemSendRequiredInputSchema: z.ZodObject<Properties<BasicCustomMailItemSendRequiredInput>> = z.object({
    text: z.string()
});

export const BasicCustomMailItemSendOptionalInputSchema: z.ZodObject<Properties<BasicCustomMailItemSendOptionalInput>> = z.object({
    shouldSendEmail: z.boolean(),
    text: z.string()
});

export const BasicCustomMailForShoppingInputSchema: z.ZodObject<Properties<BasicCustomMailForShoppingInput>> = z.object({
    atCreated: z.lazy(() => BasicCustomMailItemSendRequiredInputSchema)
});

export const BasicCustomMailForReservationOverrideInputSchema: z.ZodObject<Properties<BasicCustomMailForReservationOverrideInput>> = z.object({
    atCanceled: z.lazy(() => BasicCustomMailRequiredItemOverrideInputSchema),
    atCheckInBefore_00days: z.lazy(() => BasicCustomMailOptionalItemOverrideInputSchema),
    atCheckInBefore_01days: z.lazy(() => BasicCustomMailOptionalItemOverrideInputSchema),
    atCheckInBefore_07days: z.lazy(() => BasicCustomMailOptionalItemOverrideInputSchema),
    atCheckOutAfter_01days: z.lazy(() => BasicCustomMailOptionalItemOverrideInputSchema),
    atCreated: z.lazy(() => BasicCustomMailRequiredItemOverrideInputSchema),
    atUpdated: z.lazy(() => BasicCustomMailRequiredItemOverrideInputSchema)
});

export const BasicCustomMailForReservationInputSchema: z.ZodObject<Properties<BasicCustomMailForReservationInput>> = z.object({
    atCanceled: z.lazy(() => BasicCustomMailItemSendRequiredInputSchema),
    atCheckInBefore_00days: z.lazy(() => BasicCustomMailItemSendOptionalInputSchema),
    atCheckInBefore_01days: z.lazy(() => BasicCustomMailItemSendOptionalInputSchema),
    atCheckInBefore_07days: z.lazy(() => BasicCustomMailItemSendOptionalInputSchema),
    atCheckOutAfter_01days: z.lazy(() => BasicCustomMailItemSendOptionalInputSchema),
    atConfirmed: z.lazy(() => BasicCustomMailItemSendRequiredInputSchema),
    atCreated: z.lazy(() => BasicCustomMailItemSendRequiredInputSchema),
    atDeclined: z.lazy(() => BasicCustomMailItemSendRequiredInputSchema),
    atRequest: z.lazy(() => BasicCustomMailItemSendRequiredInputSchema),
    atUpdated: z.lazy(() => BasicCustomMailItemSendRequiredInputSchema)
});

export const BankInfoInputSchema: z.ZodObject<Properties<BankInfoInput>> = z.object({
    bankAccountHolderName: z.string(),
    bankAccountNumber: z.string(),
    bankAccountType: z.string(),
    bankName: z.string(),
    branchName: z.string()
});

export const HotelPolicyInputSchema: z.ZodObject<Properties<HotelPolicyInput>> = z.object({
    additionalFees: z.array(z.lazy(() => AdditionalFeeItemInputSchema)),
    amenities: z.array(AmenitySchema),
    baseReservationType: ReservationTypeSchema.nullish(),
    calcAdultPriceAsTotalNum: z.boolean(),
    cancelPolicy: z.array(z.lazy(() => CancelPolicyItemInputSchema)),
    checkInEnd: z.string(),
    checkInStart: z.string(),
    checkOut: z.string(),
    defaultInitPeopleNum: z.number(),
    defaultPlanID: z.string().nullish(),
    facilities: z.array(FacilitySchema),
    hideMailMagazineQuestion: z.boolean(),
    hotelInfo: z.array(z.lazy(() => HotelInfoItemInputSchema)),
    id: z.string(),
    isCalendarStartFromAvailableMonth: z.boolean(),
    isLocalPaymentAvailable: z.boolean(),
    isShowBestRateNotice: z.boolean().nullish(),
    isShowPlanIncludedPrice: z.boolean(),
    isShowRoomPriceInCalender: z.boolean(),
    kidsCosleepingPolicy: z.lazy(() => KidsCosleepingPolicyInputSchema.nullish()),
    kidsPolicy: z.array(z.lazy(() => KidsPolicyItemInputSchema)),
    localPaymentCancelFeeTransferInfo: z.lazy(() => BankInfoInputSchema.nullish()),
    localPaymentCancelFeeTransferLimitDays: z.number().nullish(),
    questions: z.array(z.lazy(() => QuestionItemInputSchema)),
    requiredPlanSelectForReservation: z.boolean(),
    requiredPrepMillisecond: z.number()
});

export const AirHostSettingsInputSchema: z.ZodObject<Properties<AirHostSettingsInput>> = z.object({
    airHostAPIAccessToken: z.string(),
    airHostPartnerID: z.string(),
    airHostPropertyID: z.string(),
    chillnnRoomAndAirHostPricePlanMappings: z.array(z.lazy(() => ChillnnRoomAndAirHostPricePlanMappingItemInputSchema))
});

export const AddressObjectInputSchema: z.ZodObject<Properties<AddressObjectInput>> = z.object({
    city: z.string().nullish(),
    nationality: z.string().nullish(),
    other: z.string().nullish(),
    postalCode: z.string().nullish(),
    pref: z.string().nullish(),
    state: z.string().nullish(),
    town: z.string().nullish()
});

export const RoomInputSchema: z.ZodObject<Properties<RoomInput>> = z.object({
    address: z.lazy(() => AddressObjectInputSchema.nullish()),
    amenities: z.array(AmenitySchema),
    availablePlanIDs: z.array(z.string()),
    beds: z.array(z.lazy(() => BedItemInputSchema)),
    capacityAdultMaximum: z.number(),
    capacityKidsMaximum: z.number(),
    capacityPeopleMaximum: z.number(),
    catchCopy: z.string(),
    description: z.string(),
    geoLocation: z.lazy(() => GeoLocationInputSchema.nullish()),
    hotelID: z.string(),
    inSale: z.boolean(),
    isDormitoryType: z.boolean(),
    isExtendSiteControllerPeopleNum: z.boolean(),
    isKidsUnavailable: z.boolean(),
    isNotDiscountTarget: z.boolean().nullish(),
    isShowStockPreview: z.boolean().nullish(),
    keyVisuals: z.array(z.lazy(() => S3ObjectInputSchema)).nullish(),
    kidsPolicy: z.array(z.lazy(() => KidsPolicyItemInputSchema)).nullish(),
    mainKeyVisual: z.lazy(() => S3ObjectInputSchema),
    maxRoomNum: z.number(),
    name: z.string(),
    overSiteControllerPeopleNum: z.array(z.lazy(() => OverSiteControllerPeopleNumInputSchema)).nullish(),
    requiredPrepMillisecond: z.number(),
    roomID: z.string(),
    roomSize: z.number().nullish(),
    saleTypeForPlan: SaleTypeForPlanSchema
});

export const RoomI18nInputSchema: z.ZodObject<Properties<RoomI18nInput>> = z.object({
    address: z.lazy(() => AddressObjectInputSchema.nullish()),
    catchCopy: z.string(),
    description: z.string(),
    hotelID: z.string(),
    lang: LangCodeSchema,
    name: z.string(),
    roomID: z.string()
});

export const HotelInputSchema: z.ZodObject<Properties<HotelInput>> = z.object({
    address: z.lazy(() => AddressObjectInputSchema.nullish()),
    catchCopy: z.string().nullish(),
    companyID: z.string(),
    customTypeRoomTitle: CustomTypeRoomTitleSchema.nullish(),
    email: z.string().nullish(),
    facebookURL: z.string().nullish(),
    geoLocation: z.lazy(() => GeoLocationInputSchema.nullish()),
    hotelID: z.string(),
    inSale: z.boolean(),
    instagramURL: z.string().nullish(),
    keyVisuals: z.array(z.lazy(() => S3ObjectInputSchema)).nullish(),
    lineURL: z.string().nullish(),
    logoImage: z.lazy(() => S3ObjectInputSchema.nullish()),
    mainKeyVisual: z.lazy(() => S3ObjectInputSchema.nullish()),
    name: z.string(),
    tel: z.string().nullish(),
    threadsURL: z.string().nullish(),
    twitterURL: z.string().nullish()
});

export const HotelI18nInputSchema: z.ZodObject<Properties<HotelI18nInput>> = z.object({
    address: z.lazy(() => AddressObjectInputSchema.nullish()),
    catchCopy: z.string().nullish(),
    companyID: z.string(),
    hotelID: z.string(),
    lang: LangCodeSchema,
    name: z.string().nullish()
});

export const AdditionalFeeKidsPriceObjectInputSchema: z.ZodObject<Properties<AdditionalFeeKidsPriceObjectInput>> = z.object({
    kidsMaxAge: z.number(),
    price: z.lazy(() => PriceObjectInputSchema)
});

export const AdditionalFeeItemInputSchema: z.ZodObject<Properties<AdditionalFeeItemInput>> = z.object({
    additionalID: z.string(),
    billingTypeTarget: BillingTypeTargetSchema,
    billingTypeTerm: BillingTypeTermSchema,
    billingTypeTermValidation: BillingTypeTermValidationSchema.nullish(),
    isExcludeCancelFeeTarget: z.boolean().nullish(),
    isExcludedConsumptionTax: z.boolean().nullish(),
    isNotDiscountTarget: z.boolean().nullish(),
    isNotTargetOnDayTrip: z.boolean().nullish(),
    kidsPrices: z.array(z.lazy(() => AdditionalFeeKidsPriceObjectInputSchema)).nullish(),
    name: z.string(),
    price: z.lazy(() => PriceObjectInputSchema),
    termValidationApplyEndDt: z.string().nullish(),
    termValidationApplyStartDt: z.string().nullish(),
    useKidsPrice: z.boolean().nullish()
});
